<template>
  <div class="fixed top-0 right-0 z-50 px-1 pt-1 ml-auto">
    <transition-group name="toast" tag="div">
      <div v-for="(toast, key) in toasts" v-bind:key="`${key}`">

        <div class="relative flex items-center py-2 pl-3 pr-2 mb-1 border-l-4 shadow-md"
             :class="[ variantColor[toast.variant].bg, variantColor[toast.variant].border ]">

          <div class="mr-3 bg-white rounded-full">
            <img :src="`/assets/toast/${toast.variant}.svg`" :alt="toast.variant" />
          </div>

          <div class="max-w-xs pr-4 text-white">
            {{ toast.message }}
          </div>

          <div class="relative ml-auto text-white cursor-pointer" v-on:click="deleteToast(key)">
            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

        </div>

      </div>

    </transition-group>
  </div>
</template>

<style lang="postcss">
.toast-enter-active, .toast-leave-active {
  transition: all 0.5s;
}
.toast-enter, .toast-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>

<script lang="ts">
import Vue from 'vue';
import { Toast, ToastMessage, TOAST_EVENT } from '@/core/toast';

const DEFAULT_TIMEOUT = 4000;

interface Data {
  toasts: Record<number, ToastMessage>,
  idCount: number,
}

export default Vue.extend({
  data(): Data {
    return {
      toasts: {},
      idCount: 0,
    };
  },
  computed: {
    variantColor() {
      return {
        success: {
          bg: 'bg-green-500',
          border: 'border-green-700',
        },
        info: {
          bg: 'bg-blue-500',
          border: 'border-blue-700',
        },
        warning: {
          bg: 'bg-yellow-500',
          border: 'border-yellow-700',
        },
        danger: {
          bg: 'bg-red-500',
          border: 'border-red-700',
        },
      };
    }
  },
  mounted() {
    this.$root.$on(TOAST_EVENT, (message) => this.createToast(message));

    Toast.initialize(this.$root);
  },
  methods: {
    createToast(message: ToastMessage) {
      const id = this.idCount++;

      this.$set(this.toasts, id, message);

      setTimeout(() => this.deleteToast(id), DEFAULT_TIMEOUT);
    },
    deleteToast(id: number) {
      this.$delete(this.toasts, id);
    }
  }
});
</script>
